import { cva, type VariantProps } from 'class-variance-authority';

/**
 * CheckboxButton size variants — aligned with Button atomic (sm, lg).
 * Same height, padding, and typography as Button for consistent toolbar/row layout.
 */
export const checkboxButtonSizeVariants = cva('', {
  variants: {
    size: {
      sm: 'h-10.5 px-4 py-2.5 text-b5 leading-b5',
      lg: 'h-11 px-6 py-2.5 text-b4 leading-b4',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export type CheckboxButtonSizeVariantProps = VariantProps<
  typeof checkboxButtonSizeVariants
>;
